// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__D0SaG","defaultTriggerClassName":"styles_defaultTriggerClassName__BDe6M"};